import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { serchSelect } from "@/mixins/index";
import { addafLinks, returnafLinks, updateafLinks } from "@/api/dataAll/afdetectLinks";
import { getadvLocation } from "@/api/dataAll/advLocation";
import { allChannel } from "@/api/aymentsdk/getchancllist";
export default {
  name: "addLinks",
  props: {
    showing: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _ref;

    return _ref = {
      dialogFormVisible: false,
      titleName: "修改af监测链接",
      id: "",
      form: {
        game: "",
        platform: "",
        channel: "",
        pag: ''
      },
      gameId: "",
      value1: "",
      value2: []
    }, _defineProperty(_ref, "id", ""), _defineProperty(_ref, "rules", {
      game: [{
        required: true,
        message: "游戏",
        trigger: "blur"
      }],
      platform: [{
        required: true,
        message: "平台",
        trigger: "blur"
      }],
      channel: [{
        required: true,
        message: "渠道",
        trigger: "blur"
      }],
      // adv_platfrom: [
      //   { required: true, message: "登录渠道", trigger: "blur" },
      // ],
      // adv_place: [{ required: true, message: "广告位置", trigger: "blur" }],
      pkg: [{
        required: true,
        message: "包名",
        trigger: "blur"
      }]
    }), _defineProperty(_ref, "formLabelWidth", "80px"), _ref;
  },
  created: function created() {
    var _this = this;

    this.searchMark = {};
    searchgame().then(function (res) {
      _this.searchgames = res.data;
      _this.gameId = res.data.id;
    });
  },
  computed: {
    isShow: {
      get: function get() {
        if (this.showing) {
          return this.showing;
        }
      },
      set: function set(val) {
        this.$emit("changeShow", false);
      }
    }
  },
  methods: {
    init: function init(id, num) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var tid, _yield$returnafLinks, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.dialogFormVisible = true;

                if (num == 1) {
                  _this2.titleName = "创建af监测链接";
                  _this2.form = {};
                }

                _this2.id = id;

                if (!(id != "t")) {
                  _context.next = 23;
                  break;
                }

                if (!(num == 2)) {
                  _context.next = 23;
                  break;
                }

                _this2.titleName = "修改af监测链接";
                _this2.id = id;
                tid = {
                  id: id
                };
                _context.next = 10;
                return returnafLinks(tid);

              case 10:
                _yield$returnafLinks = _context.sent;
                data = _yield$returnafLinks.data;
                _this2.form.game = data.game;
                _this2.searchMark.game = _this2.form.game;
                _this2.form.platform = data.platform;
                _this2.searchMark.platform = _this2.form.platform;
                _this2.form.channel = data.channel;
                _this2.searchMark.channel = _this2.form.channel;
                _this2.form.pkg = data.pkg;
                _this2.searchMark.pkg = _this2.form.pkg;
                _this2.form.id = data.id;
                _this2.searchMark.id = _this2.form.id; // this.platformchange(data.platform_id)

                _this2.$set(_this2.form, _this2.form.game, "");

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.$emit("changeShow", false);
    },
    // getAllChannel() {
    //   allChannel().then((res) => {
    //     this.advchannels = res.data;
    //   });
    //   
    // },
    advChannelchange: function advChannelchange(id) {
      var _this3 = this;

      if (id != "") {
        getadvLocation({
          advplatform_id: id
        }).then(function (res) {
          _this3.advLocation = res.data;
        });
      } else {
        this.form.advLocation = ""; // this.searchMark.ad_placement = "";
        // this.searchMark.ad_channel = "";

        this.form.advChannel = "";
        this.advLocation = [];
      }
    },
    advLocationchange: function advLocationchange(id) {
      if (id != "") {
        // debugger
        this.advLocation.forEach(function (item) {
          if (item.id == id) {}
        });
      } else {
        this.searchMark.ad_placement = "";
      }
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this4 = this;

      if (this.titleName == "创建af监测链接") {
        this.searchMark.kind = 1;
        addafLinks(this.searchMark).then(function (res) {
          if (res.status == 200) {
            Message.success(res.message);

            _this4.resetForm("ruleForm");
          } else {
            Message.warning(res.message);

            _this4.resetForm("ruleForm");
          }
        });
      }

      if (this.titleName == "修改af监测链接") {
        updateafLinks(this.searchMark).then(function (res) {
          if (res.status == 200) {
            Message.success(res.message);

            _this4.resetForm("ruleForm");
          } else {
            Message.warning(res.message);

            _this4.resetForm("ruleForm");
          }
        });
      }
    },
    clearData: function clearData() {
      this.form = {};
      this.searchplatforms = [];
      this.searchchannels = [];
      this.searchpkg = []; // let tid = {
      //   id: this.id,
      // };
      // resetgateway(tid).then((res) => {
      //   if (res.status == 200) {
      //     Message.success(res.message);
      //     this.$emit("refreshDataList");
      //     this.resetForm("ruleForm");
      //   } else {
      //     Message.warning(res.message);
      //   }
      // });
    }
  }
};